import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShellComponent } from './shell/shell.component';
import { MainContentComponent } from './shell/main-content/main-content.component';
import { TopBarComponent } from './shell/top-bar/top-bar.component';
import { AdminComponent } from '../admin/dashboard/admin.component';
import { SubmissionDetailComponent } from '../admin/submission-detail/submission-detail.component';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from './../shared/shared.module';
import { EditorComponent } from 'app/editor/editor.component';

const routes: Routes = [
  {
    path: '',
    // loadChildren: () => import('./../editor/editor.module').then(m => m.EditorModule)
    component:EditorComponent
  }
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forRoot(routes)
  ],
  declarations: [
    ShellComponent,
    MainContentComponent,
    TopBarComponent
  ],
  exports: [
    ShellComponent
  ]
})
export class CoreModule { }
